// extracted by mini-css-extract-plugin
export default {"PrivacyPolicy":"PrivacyPolicy_PrivacyPolicy__OCXDC"};